import { render, staticRenderFns } from "./metrics_assignment_view.vue?vue&type=template&id=03b27cbc&scoped=true&"
import script from "./metrics_assignment_view.vue?vue&type=script&lang=js&"
export * from "./metrics_assignment_view.vue?vue&type=script&lang=js&"
import style0 from "./metrics_assignment_view.vue?vue&type=style&index=0&id=03b27cbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b27cbc",
  null
  
)

export default component.exports